module.exports = __webpack_public_path__ + "static/il-platba-f44d422136d941d884b93dd2d3c7e0c6.svg";